import { createAction } from "redux-actions";

import { IImportReport } from "../../../../api/CourseAuthorApi";
import { IOrganizationTree } from "../../../../api/ResolveApi/resolve-api.types";
import { IClientPatch, IPatchAction } from "../../../../components/course-author/helpers/patches";
import { IFullOrganization } from "../../../../parsers/resolve";
import { IChangeOrganizationName, ICompleteOrganization } from "../../../types/common";
import { IErrorMessage, IFetchInitialData, IMiddleError, IProgressSteps, ISettingsFile } from "../types";

export enum Action {
  CREATE_NEW_ORGANIZATION = "ORG_SETTINGS/CREATE_ORGANIZATION",
  HANDLE_CREATE_NEW_ORGANIZATION_FAILURE = "ORG_SETTINGS/HANDLE_CREATE_NEW_ORGANIZATION_FAILURE",
  HANDLE_CREATE_NEW_ORGANIZATION_SUCCESS = "ORG_SETTINGS/HANDLE_CREATE_NEW_ORGANIZATION_SUCCESS",
  FETCH_INITIAL_DATA = "ORG_SETTINGS/FETCH_INITIAL_DATA",
  FETCH_ORG_PREVIEW = "ORG_SETTINGS/PREVIEW",
  GET_ORG_INFO = "ORG_SETTINGS/INFO",
  HANDLE_ORGANIZATION_PREVIEW_SUCCESS = "ORG_SETTINGS/HANDLE_ORGANIZATION_PREVIEW_SUCCESS",
  HANDLE_ORGANIZATION_PREVIEW_FAILURE = "ORG_SETTINGS/HANDLE_ORGANIZATION_PREVIEW_FAILURE",
  HANDLE_FETCH_INITIAL_DATA_FAILURE = "ORG_SETTINGS/HANDLE_FETCH_INITIAL_DATA_FAILURE",
  HANDLE_FETCH_INITIAL_DATA_SUCCESS = "ORG_SETTINGS/HANDLE_FETCH_INITIAL_DATA_SUCCESS",
  HANDLE_DELETE_ORGANIZATION_FROM_PREVIEW_SUCCESS = "ORG_SETTINGS/DELETE_ORGANIZATION_FROM_PREVIEW_SUCCESS",
  HANDLE_DELETE_ORGANIZATION_FROM_PREVIEW_FAILURE = "ORG_SETTINGS/DELETE_ORGANIZATION_FROM_PREVIEW_FAILURE",
  HANDLE_GET_ORG_INFO_SUCCESS = "ORG_SETTINGS/INFO_SUCCESS",
  HANDLE_GET_ORG_INFO_FAILURE = "ORG_SETTINGS/INFO_FAILURE",
  DELETE_ORGANIZATION = "ORG_SETTINGS/DELETE_ORGANIZATION",
  DELETE_ORGANIZATION_FROM_PREVIEW = "ORG_SETTINGS/DELETE_ORGANIZATION_FROM_PREVIEW",
  PATCH_REQUEST = "ORG_SETTINGS/PATCH_REQUEST",
  PATCH_REQUEST_FAILURE = "ORG_SETTINGS/PATCH_REQUEST_FAILURE",
  PATCH_REQUEST_SUCCESS = "ORG_SETTINGS/PATCH_REQUEST_SUCCESS",
  PATCH_REQUEST_IMPORT = "ORG_SETTINGS/PATCH_REQUEST_IMPORT",
  PATCH_REQUEST_IMPORT_FAILURE = "ORG_SETTINGS/PATCH_REQUEST_IMPORT_FAILURE",
  PATCH_REQUEST_IMPORT_SUCCESS = "ORG_SETTINGS/PATCH_REQUEST_IMPORT_SUCCESS",
  REFRESH_SETTINGS = "ORG_SETTINGS/REFRESH_SETTINGS",
  REFRESH_SETTINGS_FAILURE = "ORG_SETTINGS/REFRESH_SETTINGS_FAILURE",
  REFRESH_SETTINGS_SUCCESS = "ORG_SETTINGS/REFRESH_SETTINGS_SUCCESS",
  REQUEST_ALL_USER_DATA = "ORG_SETTINGS/REQUEST_ALL_USER_DATA",
  REQUEST_ALL_ASSESSMENT_DATA = "ORG_SETTINGS/REQUEST_ALL_ASSESSMENT_DATA",
  REQUEST_ALL_TABLE_DATA_MIDDLE_ERROR = "ORG_SETTINGS/REQUEST_ALL_TABLE_DATA_MIDDLE_ERROR",
  REQUEST_ALL_TABLE_DATA_FATAL_ERROR = "ORG_SETTINGS/REQUEST_ALL_TABLE_DATA_FATAL_ERROR",
  REQUEST_ALL_TABLE_DATA_FINISHED = "ORG_SETTINGS/REQUEST_ALL_TABLE_DATA_FINISHED",
  STEP_ON_ALL_TABLE_DATA = "ORG_SETTINGS/STEP_ON_ALL_TABLE_DATA",
  MOUNT = "ORG_SETTINGS/MOUNT",
  UNMOUNT = "ORG_SETTINGS/UNMOUNT",
}

export const mount = createAction<void>(Action.MOUNT);
export const unmount = createAction<void>(Action.UNMOUNT);
export const fetchInitialData = createAction<void>(Action.FETCH_INITIAL_DATA);

/* organization preview        */
export const fetchOrganizationPreview = createAction<void>(Action.FETCH_ORG_PREVIEW);
export const handleOrganizationPreviewSuccess = createAction<IOrganizationTree>(
  Action.HANDLE_ORGANIZATION_PREVIEW_SUCCESS
);
export const handleOrganizationPreviewFailure = createAction<{
  message: string;
}>(Action.HANDLE_ORGANIZATION_PREVIEW_FAILURE);
/* end of organization preview */

export const fetchInitialDataFailure = createAction<{ message: string }>(Action.HANDLE_FETCH_INITIAL_DATA_FAILURE);
export const fetchInitialDataSuccess = createAction<IFetchInitialData>(Action.HANDLE_FETCH_INITIAL_DATA_SUCCESS);
export const deleteOrganization = createAction<void>(Action.DELETE_ORGANIZATION);
export const patchRequest = createAction<IClientPatch<IPatchAction>>(Action.PATCH_REQUEST);
export const patchRequestFailure = createAction<{ message: string }>(Action.PATCH_REQUEST_FAILURE);
export const patchRequestSuccess = createAction<ICompleteOrganization>(Action.PATCH_REQUEST_SUCCESS);
export const refreshSettings = createAction<void>(Action.REFRESH_SETTINGS);
export const refreshSettingsFailure = createAction<{ message: string }>(Action.REFRESH_SETTINGS_FAILURE);
export const refreshSettingsSuccess = createAction<IFetchInitialData>(Action.REFRESH_SETTINGS_SUCCESS);
export const patchRequestImport = createAction<ISettingsFile>(Action.PATCH_REQUEST_IMPORT);
export const patchRequestImportFailure = createAction<IErrorMessage>(Action.PATCH_REQUEST_IMPORT_FAILURE);
export const patchRequestImportSuccess = createAction<IImportReport>(Action.PATCH_REQUEST_IMPORT_SUCCESS);
export const requestAllUserData = createAction<void>(Action.REQUEST_ALL_USER_DATA);
export const requestAllAssessmentData = createAction<void>(Action.REQUEST_ALL_ASSESSMENT_DATA);
export const requestAllTableDataFinished = createAction<void>(Action.REQUEST_ALL_TABLE_DATA_FINISHED);
export const stepOnAllTableDataRequest = createAction<IProgressSteps>(Action.STEP_ON_ALL_TABLE_DATA);
export const middleErrorReport = createAction<IMiddleError>(Action.REQUEST_ALL_TABLE_DATA_MIDDLE_ERROR);
export const requestAllTableDataFatalError = createAction<{ message: string }>(
  Action.REQUEST_ALL_TABLE_DATA_FATAL_ERROR
);

export const createNewOrganization = createAction<IFullOrganization>(Action.CREATE_NEW_ORGANIZATION);

export const handleCreateNewOrganizationFailure = createAction<{
  message: string;
}>(Action.HANDLE_CREATE_NEW_ORGANIZATION_FAILURE);

export const handleCreateNewOrganizationSuccess = createAction<IOrganizationTree>(
  Action.HANDLE_CREATE_NEW_ORGANIZATION_SUCCESS
);

export const getOrgInfo = createAction<IChangeOrganizationName>(Action.GET_ORG_INFO);
export const handleGetOrgInfoSuccess = createAction<IOrganizationTree>(Action.HANDLE_GET_ORG_INFO_SUCCESS);
export const handleGetOrgInfoFailure = createAction<{ message: string }>(Action.HANDLE_GET_ORG_INFO_FAILURE);

export const deleteOrganizationFromPreview = createAction<string>(Action.DELETE_ORGANIZATION_FROM_PREVIEW);
export const handleDeleteOrganizationFromPreviewSuccess = createAction<IOrganizationTree | null>(
  Action.HANDLE_DELETE_ORGANIZATION_FROM_PREVIEW_SUCCESS
);
export const handleDeleteOrganizationFromPreviewFailure = createAction<{
  message: string;
}>(Action.HANDLE_DELETE_ORGANIZATION_FROM_PREVIEW_FAILURE);
